import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

//const baseUrl = "http://localhost:9000";
const baseUrl = "https://communityoflearning.accenture.com/communityoflearning-apis";
const getAuthHeader = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: token,
    },
  };
};

export const fetchCommentsByAnswer = createAsyncThunk(
  "comments/fetchByAnswer",
  async (answerId, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${baseUrl}/comments/${answerId}`,
        getAuthHeader()
      );

      return { answerId, comments: res.data };

    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch comments"
      );
    }
  }
);

export const createComment = createAsyncThunk(
  "comments/create",
  async ({ answerId, comment }, { rejectWithValue }) => {
    try {
      await axios.post(
        `${baseUrl}/comments`,
        { answerId, comment },
        getAuthHeader()
      );

      return answerId;

    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to create comment"
      );
    }
  }
);

export const deleteComment = createAsyncThunk(
  "comments/delete",
  async ({ answerId, commentId }, { rejectWithValue }) => {
    try {
      await axios.delete(
        `${baseUrl}/comments/${commentId}`,
        getAuthHeader()
      );

      return answerId;

    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to delete comment"
      );
    }
  }
);

const commentsSlice = createSlice({
  name: "comments",
  initialState: {
    byAnswerId: {},
  },
  reducers: {
    clearComments: (state) => {
      state.byAnswerId = {};
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(fetchCommentsByAnswer.pending, (state, action) => {
        const answerId = action.meta.arg;

        state.byAnswerId[answerId] = {
          ...(state.byAnswerId[answerId] || {}),
          loading: true,
          error: null,
        };
      })

      .addCase(fetchCommentsByAnswer.fulfilled, (state, action) => {
        const { answerId, comments } = action.payload;

        state.byAnswerId[answerId] = {
          items: comments,
          loading: false,
          error: null,
        };
      })

      .addCase(fetchCommentsByAnswer.rejected, (state, action) => {
        const answerId = action.meta.arg;

        state.byAnswerId[answerId] = {
          items: [],
          loading: false,
          error: action.payload,
        };
      });
  },
});

export const { clearComments } = commentsSlice.actions;
export default commentsSlice.reducer;